import React, { useState, useEffect } from "react";
import {Container,Typography,Button,CircularProgress,Box,Grid,} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import axios from "axios";
import Swal from "sweetalert2";
import { BASE_URL } from "../../App";

const MechanicReportExcelDownload = () => {
  const [schemes, setSchemes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloadingId, setDownloadingId] = useState(null);
  const BRANCH_CODE = localStorage.getItem("BRANCH_CODE");

  useEffect(() => {
    const fetchSchemes = async () => {
      try {
        const res = await axios.get(BASE_URL + "/getExcelSchemes");
        setSchemes(res.data.data);
      } catch (error) {
        console.error("Error fetching scheme list:", error);
        Swal.fire("Error", "Failed to load scheme list", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchSchemes();
  }, []);

  const handleDownload = async (schemeId, schemeName) => {
    try {
      setDownloadingId(schemeId);

      Swal.fire({
             title: "Downloading...",
             text: `Please wait while "${schemeName}" is being downloaded.`,
             allowOutsideClick: false,
             didOpen: () => {
               Swal.showLoading();
             },
      });

      const res = await axios.post(
        `${BASE_URL}/downloadCsv`,
        { schemeid: schemeId, branch: BRANCH_CODE },
        { responseType: "blob" }
      );

      const blob = new Blob([res.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${schemeName}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      Swal.fire("Success", "Download completed!", "success");
    } catch (error) {
      console.error("Download error:", error);
      Swal.fire("Error", "Failed to download file", "error");
    } finally {
      setDownloadingId(null);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 5 }}>
      {/* <Typography variant="h4" align="center" gutterBottom fontWeight="bold">
        Mechanic Scheme Downloads
      </Typography> */}

      {loading ? (
        <Box display="flex" justifyContent="center" mt={5}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={3} mt={3}>
          {schemes.map((scheme) => (
            <Grid item xs={12} sm={6} md={4} key={scheme.scheme_id}>
              <Button
                variant="outlined"
                startIcon={<DownloadIcon />}
                fullWidth
                onClick={() => handleDownload(scheme.scheme_id, `Scheme_${scheme.scheme_id}`)}
                disabled={downloadingId === scheme.scheme_id}
                sx={{
                  textTransform: "none",
                  fontSize: "1rem",
                  padding: "1rem",
                  borderRadius: "12px",
                  borderColor: "#1976d2",
                  color: "#1976d2",
                  fontWeight: "600",
                  "&:hover": {
                    backgroundColor: "#e3f2fd",
                    borderColor: "#1565c0",
                  },
                }}
              >
                {downloadingId === scheme.scheme_id
                  ? "Downloading..."
                  : `Download - Scheme ${scheme.scheme_id}`}
              </Button>
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
};

export default MechanicReportExcelDownload;
